import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=3418ab71&scoped=true&"
import script from "./GeneralDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDetails.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDetails.vue?vue&type=style&index=0&id=3418ab71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418ab71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3418ab71')) {
      api.createRecord('3418ab71', component.options)
    } else {
      api.reload('3418ab71', component.options)
    }
    module.hot.accept("./GeneralDetails.vue?vue&type=template&id=3418ab71&scoped=true&", function () {
      api.rerender('3418ab71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/smsRegistrationComponents/GeneralDetails.vue"
export default component.exports